<template>
    <v-app class="container">
        <v-content>
            <v-container>
                <div>
                    <img src="@/assets/form2/anatomy.png" usemap="#anatomy-map" width="420px">
                    <span v-for="(part, x) in parts" :key="part['id']">
                        <input type="checkbox" v-model="anatomy" :id="'test'+(x+1)" :value="part.name">
                        <label :for="'test'+(x+1)" class="circle" :class="part.name"></label>
                        <label :for="'test'+(x+1)" :class="'tag'+(x+1)">{{part.name}}</label>
                    </span>
                </div>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
import db from '@/components/firebase.init';
export default {
    data(){
        return{
            anatomy:[],
            parts:[
                {
                    name:'neck',
                },
                {
                    name:'shoulder',
                },
                {
                    name:'elbow',
                },
                {
                    name:'wrist',
                },
                {
                    name:'back',
                },
                {
                    name:'hip',
                },
                {
                    name:'knee',
                },
                {
                    name:'ankle',
                },
            ]
        }
        
    },
    methods:{
        submit(id){
       
            db.collection('forms').doc(id).update(
                {
                    anatomy: this.anatomy
                    
                }
            )
            .then(data =>{
                console.log(id);
            })
        },
    }
}
</script>

<style scoped>
div{
    position: relative;
}
.circle {
    width:15px;
    height:15px;
    position: absolute;    
    background-color:rgb(0, 255, 0);
    border-radius:10px;
    /* opacity: .8; */
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    transition: all .4s;
    border: solid 2px #ccc;
}
.circle:hover {
    transform: scale(1.5);
    transition: all .4s;
    border-radius:15px;
    cursor: pointer;
}
label {
    cursor: pointer;
}
.circle.neck{
    left: 90px;
    top: 50px;

}
.tag1 {
    position: absolute;
    left: 190px;
    top: 10%;
    color: default;
}

.circle.shoulder{
    left: 125px;
    top: 70px;
}
.tag2 {
    position: absolute;
    left: 180px;
    top: 18%;
    color: default;
}

.circle.elbow{
    left: 125px;
    top: 130px;

}
.tag3 {
    position: absolute;
    left: 190px;
    top: 25%;
    color: default;
}
.circle.wrist{
    left: 140px;
    top: 190px;
}
.tag4 {
    position: absolute;
    left: 190px;
    top: 33%;
    color: default;
}
.circle.back{
    left: 330px;
    top: 160px;

}
.tag5{
    position: absolute;
    left: 190px;
    top: 40%;
    color: default;
}
.circle.hip{
    left: 100px;
    top: 220px;
}
.tag6{
    position: absolute;
    left: 190px;
    top: 55%;
    color: default;
}
.circle.knee{
    left: 90px;
    top: 290px;
}
.tag7{
    position: absolute;
    left: 190px;
    top: 65%;
    color: default;
}
.circle.ankle{
    left: 90px;
    top: 370px;
}
.tag8{
    position: absolute;
    left: 190px;
    top: 82%;
    color: default;
}

input[type=checkbox] {
    position: absolute;
    height: 0;
    width: 0;
    opacity: 0;
 }
 #test1[type=checkbox]:checked ~ .tag1, #test2[type=checkbox]:checked ~ .tag2 , #test3[type=checkbox]:checked ~ .tag3, #test4[type=checkbox]:checked ~ .tag4, #test5[type=checkbox]:checked ~ .tag5, #test6[type=checkbox]:checked ~ .tag6, #test7[type=checkbox]:checked ~ .tag7, #test8[type=checkbox]:checked ~ .tag8{
    color: red;
}
 input[type="checkbox"]:checked + label.circle{
    border: solid 2px rgb(255, 255, 255 );
    background-color: rgba(255, 0, 0, 1);
    transform: scale(1);
    border-radius:15px;    
}

</style>

